import { CarrierVisitsApi, NonNumericOrderDto } from '@planning/app/api'
import { createApiClient } from '@planning/app/http-client'
import { Event, IEvent, IQueryHandler, IQueryMessage } from '@tom-ui/utils'

export class GetNnrOrdersByVisitIdsQuery implements IQueryMessage {
  static type = 'GetNnrOrdersByVisitIdsQuery'
  type = GetNnrOrdersByVisitIdsQuery.type
  constructor(public visitIds: number[]) {}
  getKey = () => JSON.stringify(this)
}

const httpClient = createApiClient(CarrierVisitsApi)

export const getNnrOrdersByVisitIdsQueryHandler: IQueryHandler<
  GetNnrOrdersByVisitIdsQuery,
  IEvent<NonNumericOrderDto[]>
> = async query => {
  const { data } = await httpClient.nonNumericOrdersBatch({ ids: query.visitIds })
  return new Event(GetNnrOrdersByVisitIdsQuery.type, data)
}
